import { useProduct } from '../../index.js'
import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { getModeHasController } from '../../utils/modeRegistry.js'
import { PRODUCT_VIEW_MODE } from '../../constants/viewModes.js'

import { InfoModeController } from './InfoModeController.jsx'
import { InsolationController } from './InsolationController.jsx'

import styles from './ModeControllerPane.module.scss'

/**
 * ModeControllerPane — renders the appropriate controller UI for the active mode.
 *
 * Controller dispatch (by activeMode):
 *   INFO        → InfoModeController   (color scheme select + desc + legend)
 *   INSOLATION  → InsolationController (time slider + focused compartment)
 *   HOTSPOT     → no controller (hasController: false)
 *   ARRANGE     → no controller (hasController: false)
 *   AXONOMETRIC → no controller (hasController: false)
 *
 * Always visible — no CollapsiblePane wrapper. The section header is a plain
 * non-interactive label. This also avoids the overflow:hidden clip that would
 * cut off the Select dropdown.
 */
export function ModeControllerPane() {
  const { t } = useI18n()
  const { modes } = useProduct()
  const activeMode = modes?.activeMode ?? null

  if (!activeMode || !getModeHasController(activeMode)) return null

  let controller = null
  if (activeMode === PRODUCT_VIEW_MODE.INFO) {
    controller = <InfoModeController />
  } else if (activeMode === PRODUCT_VIEW_MODE.INSOLATION) {
    controller = <InsolationController />
  }

  if (!controller) return null

  return (
    <div className={styles.pane}>
      {/* <p className={styles.heading}>{t(`product.mode_${activeMode}`)}</p> */}
      {controller}
    </div>
  )
}
